import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Panel } from '../../ui/index.ts';
import styles from './Account.module.css';

/**
 * The "inbox" of the stand-in account backend: the e-mails it would have sent show up here so that
 * the sign-in flows can be followed by hand. Only the development backend puts a handle on
 * `window`, so in any other build this renders nothing.
 */
export function DemoMailbox() {
  const { t } = useTranslation('account');
  const [mail, setMail] = useState<{ to: string; code: string } | null>(null);

  useEffect(() => {
    const read = (): void => {
      const last = window.__colpoAccount?.lastMail();
      setMail((old) => {
        const next = last ? { to: last.to, code: last.code } : null;
        return old?.to === next?.to && old?.code === next?.code ? old : next;
      });
    };
    read();
    const id = setInterval(read, 500);
    return () => {
      clearInterval(id);
    };
  }, []);

  return (
    <Panel className={styles['mailbox']} title={t('demo.mailTitle')}>
      {mail ? (
        <div className={styles['stack']} data-testid="demo-mail">
          <span className={styles['note']}>{t('demo.mailLast', { to: mail.to })}</span>
          <span className={styles['mailCode']}>{mail.code}</span>
        </div>
      ) : (
        <p className={styles['note']}>{t('demo.mailEmpty')}</p>
      )}
    </Panel>
  );
}
